import { render } from "./ValidatedTextarea.vue?vue&type=template&id=09287594&scoped=true"
import script from "./ValidatedTextarea.vue?vue&type=script&lang=js"
export * from "./ValidatedTextarea.vue?vue&type=script&lang=js"

import "./ValidatedTextarea.vue?vue&type=style&index=0&id=09287594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09287594"]])

export default __exports__